import keyMirror from "keymirror";

export const AiInsightsConstants = {
  ActionTypes: keyMirror({
    SET_MESSAGE: null,
    GET_AI_INSIGHTS_CATEGORIES_REQUEST: null,
    GET_AI_INSIGHTS_CATEGORIES_SUCCESS: null,
    GET_AI_INSIGHTS_CATEGORIES_FAILURE: null,
    GET_AI_INSIGHTS_SELECTED_REPORT_DATA_REQUEST: null,
    GET_AI_INSIGHTS_SELECTED_REPORT_DATA_SUCCESS: null,
    GET_AI_INSIGHTS_SELECTED_REPORT_DATA_FAILURE: null,
    SET_AI_INSIGHTS_SELECTED_REPORT_TITLE: null,
    SET_AI_INSIGHTS_FEEDBACK: null,
  }),
};
